import { useContext, useCallback } from 'react'

import {
  SnackbarContext,
  ISnackbarOptions,
} from '../contexts/snackbar'

export const useSnackbar = () => {
  const snackbar = useContext(SnackbarContext)

  const error = useCallback((message: string, options?: ISnackbarOptions) => {
    snackbar.setSnackbar(message, 'error', options)
  }, [])

  const info = useCallback((message: string, options?: ISnackbarOptions) => {
    snackbar.setSnackbar(message, 'info', options)
  }, [])

  const success = useCallback((message: string, options?: ISnackbarOptions) => {
    snackbar.setSnackbar(message, 'success', options)
  }, [])

  const warning = useCallback((message: string, options?: ISnackbarOptions) => {
    snackbar.setSnackbar(message, 'warning', options)
  }, [])

  const reset = useCallback(() => {
    snackbar.setSnackbar()
  }, [])

  return {
    error,
    info,
    success,
    warning,
    reset,
  }
}

export default useSnackbar
